import styled from 'styled-components';
import { mediaQuery } from 'modules/utils';
import { setIconColor } from 'modules/utils/cssUtils';
import { Flex } from '../flex';
import { Input } from '../input';
import { theme } from '../theme';

export const StyledSearchInputContainer = styled(Flex)`
  align-items: center;
  border-bottom: 1px solid ${theme.colors.primaryW};
  padding-bottom: 0.4rem;
  width: 100%;

  ${mediaQuery('md')} {
    max-width: 35.18rem;
  }
`;

export const StyledSearchInput = styled(Input)`
  input {
    background-color: transparent;
    border: none !important;
    outline: none;

    font-size: var(--h2-font-size);
    line-height: var(--h2-line-height);
    font-weight: ${theme.fontWeight.bold};

    color: ${theme.colors.primaryW};
    ::placeholder {
      color: ${theme.colors.primaryW};
    }
  }
  ${setIconColor(theme.colors.primaryW)}
`;
